import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable, of } from 'rxjs';
import { map, catchError, switchMap } from 'rxjs/operators';
import { environment } from 'src/environments/environment';
import { CurrencyDetailACF, CurrencyDetailResponse } from '../models/currency-detail';
import { LocaleService } from '../services/locale.service';
import { ApplicationLocale } from '../models/locale';

@Injectable({
  providedIn: 'root'
})
export class CurrencyDetailService {

  constructor(
    private http: HttpClient,
    private localeService: LocaleService,
  ) {}

  getCurrencyDetail(slug: string): Observable<CurrencyDetailACF | null> {
    const baseSlug = slug.toLowerCase();

    if (this.localeService.currentLocale !== ApplicationLocale.EN) {
      const localizedSlug = `${baseSlug}_${this.localeService.currentLocale}`;
      return this.fetchBySlug(localizedSlug).pipe(
        switchMap(result => result ? of(result) : this.fetchBySlug(baseSlug))
      );
    }

    return this.fetchBySlug(baseSlug);
  }

  private fetchBySlug(slug: string): Observable<CurrencyDetailACF | null> {
    return this.http.get<CurrencyDetailResponse[]>(
      `${environment.blog.api}/currency-detail`,
      { params: { slug } }
    ).pipe(
      map(response => response?.[0]?.acf || null),
      catchError(() => of(null))
    );
  }
}
